<template>
  <v-card
    class="mb-2 grey lighten-4"
  >
    <v-card-text
      class="headline font-weight-bold"
      justify="center"
      align="center"
    >
      <div id="livechat" style="height: 60vh" />
    </v-card-text>
  </v-card>
</template>

<script>
import cfc from "@/ws/cfc";
import aulasTeorica from "@/ws/aulasTeorica";

export default {
  props: {
    linkMeet: {
      type: String,
    },
    tempObjMeet: {
      type: Object
    },
    domain: {
      type: String
    },
    jitsiExternalScript: {
      type: String
    },
    jwt: {
      type: String
    }
  },
  data() {
    return {
      apiMeet: '',
      tempoRestante: 5,
      quantBioNecessaria: 1,
      quantBioTiradas: 0,
      hasBioReturn: false,
      funcao: null,
      user: {
        nome: '',
        email: 'user.email@gmail.com'
      },
      cargaHoraria: 0,

    }
  },
  created() {
    this.loadJitsiAPI();
  },
  mounted() {
    this.setInfoUser();
    this.startConference();
    this.setSubject();
  },
  methods: {
    loadJitsiAPI() {
      // TODO encontrar uma forma de checar se o carregamento deu certo
      let externalScript = document.createElement('script')
      externalScript.setAttribute('src', this.jitsiExternalScript)
      document.head.appendChild(externalScript)
    },

    setInfoUser() {
      this.user.nome = this.$store.getters.getAluno.nome ? this.$store.getters.getAluno.nome : 'Aluno';
    },

    startConference() {
      var domain = this.domain;
      try {
        const options = {
          roomName: this.linkMeet,
          jwt: this.jwt,
          width: '100%',
          height: '100%',
          parentNode: document.getElementById('livechat'),
          configOverwrite: {
            defaultLanguage: 'ptBR',
            startWithAudioMuted: true,
            prejoinPageEnabled: false,
            disableInviteFunctions: true,
            toolbarButtons: ['chat', 'raisehand', 'camera', 'microphone'],
          },
          interfaceConfigOverwrite: {LANG_DETECTION: false},
        };
        // eslint-disable-next-line no-undef
        this.apiMeet = new JitsiMeetExternalAPI(domain, options);
      } catch (error) {
        console.log(error);
      }

      this.startRandomCounter();
    },

    setSubject() {
      this.apiMeet.executeCommand('subject', 'Aula Teórica');
    },

    startRandomCounter() {
      this.getTempo().then(() => {
        this.getCalculoTempo().then(() => {
          this.getBiometriasTiradas().then(() => {
            this.getCargaHoraria().then(() => {
              this.programarBioAleatoria();
            });
          });
        });
      });
    },

    getTempo() {
      return aulasTeorica.getTempoAula(this.tempObjMeet.id)
        .then(response => {
          this.tempoRestante = response.data.message;
        }).catch(erro => {
          console.log('erro getTempo', erro);
          this.tempoRestante = 15;
        });
    },

    getCargaHoraria() {
      return aulasTeorica.find(this.tempObjMeet.id)
        .then(response => {
          this.cargaHoraria = response.data[0].duracao
        }).catch(erro => {
          console.log('erro getCalculoTempo', erro);
        });
    },

    getCalculoTempo() {
      return cfc.getQuantidadeBiometria()
        .then(response => {
          this.quantBioNecessaria = response.data.quantidade_biometria
        }).catch(erro => {
          console.log('erro getCalculoTempo', erro);
        });
    },


    getBiometriasTiradas() {
      return aulasTeorica.getNumeroBiometriasTiradas(this.tempObjMeet.id, this.$store.getters.getAluno.id, '1')
        .then(response => {
          this.quantBioTiradas = response.data.biometrias;
        }).catch(erro => {
          console.log('erro getBiometriasTiradas', erro);
        });
    },

    programarBioAleatoria() {
      if(this.$store.getters.getCfc.uf == "MT") {
        var tempo = Math.round(this.tempoRestante / (this.quantBioNecessaria + 1));
        tempo = this.getRandomNumber();

        this.tempoRestante = this.tempoRestante - tempo;
        this.funcao = setTimeout(() => {
          if (this.quantBioTiradas < (this.cargaHoraria / 5) * this.quantBioNecessaria) {
            document.dispatchEvent(new CustomEvent('carregaModal'));
            this.quantBioTiradas++;
            this.programarBioAleatoria();
          }
        }, tempo * 60 * 1000);
      } else {
        var tempo = Math.round((this.tempoRestante) / this.quantBioNecessaria);
        tempo = this.getRandomNumberSimple(tempo);

        this.funcao = setTimeout(() => {
          if (this.quantBioTiradas < this.quantBioNecessaria) {
            document.dispatchEvent(new CustomEvent('carregaModal'));
            this.quantBioTiradas++;
            this.programarBioAleatoria();
          }
        }, tempo * 60 * 1000);

      }
    },
    getRandomNumber(min = 9, max = 12) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    getRandomNumberSimple(maximo) {
      return Math.floor(Math.random() * (maximo - 1 + 1) + 1);
    }
  }
}
</script>

